module.exports = __webpack_public_path__ + "img/SuperOK-MollyMalones-8.20-11x17.d6e2a7a3.png";